import { Grid, Typography, useEventCallback } from '@mui/material';
import { Fragment, memo, useMemo, useState } from 'react';
import { FormikErrors, FormikProps, FormikTouched } from 'formik';
import { ActFormVM, LastStepVM, ParentVM, SectionVM } from 'civil-status/view-models/step-form';
import FilterAccordionAct from 'civil-status/components/research-category/filter/filter-accordion-act';
import { ResearchAct, ActListVM } from 'civil-status/view-models/research-category-form';
import { FilterType, FilterTypeState } from 'civil-status/pages/research-category/list';
import { transformerActResearch } from 'civil-status/utils/transformer-act-research';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { transformerActCategoryList } from 'civil-status/utils/transformer-act-category-list';
import { ActCategory, ModelEventoDTO } from 'shell/models/act-category-list';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import TableAct from 'civil-status/components/research-category/table';
import ActForm from './act-form';
import { DateTime } from 'luxon';
import { transformerParent } from 'civil-status/utils/transformer-event/transformer-parent';
import { KeySections, KeySubjects } from 'civil-status/constants/keys-subjects-section';
import { initialValuesParent } from 'civil-status/constants/initial-values-step';
import { transformerGeneralData } from 'civil-status/utils/transformer-event/transform-event-343/transform-general-data';
import { clearSection } from 'civil-status/utils/clear-section';
import { transformerMarriageAct } from 'civil-status/utils/transformer-event/transform-event-343/transformer-marriage-act';
import { ID_REGISTER } from 'civil-status/components/shared/list-register';
import { MUNICIPALITY_MILANO } from 'civil-status/constants/municipality-milano';
import { transformerLawyer } from 'civil-status/utils/transformer-event/transform-event-343/transformer-lawyer';
import { transformerSeparationAct } from 'civil-status/utils/transformer-event/transform-event-343/transformer-separation-act';
import { PmiButton } from 'shell/components/shared/button';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { transformerGeneralData341 } from 'civil-status/utils/transformer-event/transform-event-341/transform-general-data';
import { toast } from 'react-toastify';
import { transformerActCurrent } from 'civil-status/utils/transformer-event/transformer-act-current';
import { transformerDatiRico350 } from 'civil-status/utils/transformer-event/transform-event-350/transformer-dati-rico';
import { transformerSeperazione } from 'civil-status/utils/transformer-event/transfomer-separazione';
import { transformerActMarriageRactod350 } from 'civil-status/utils/transformer-event/transform-event-350/transformer-act-marriage-transformer-ractod-350';
import { transformerMatrimonioAttoNascitaSposo } from 'civil-status/utils/transformer-event/transformer-matrimonio-atto-nascita-sposo';
import { transformerMatrimonioAttoNascitaSposa } from 'civil-status/utils/transformer-event/transformer-matrimonio-atto-nascita-sposa';
import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { transformerGeneralAct } from 'civil-status/utils/transformer-event/transformer-general-act';
import { IDTypologyConsent } from 'civil-status/constants/id-typology-consent';
import { CodeSection } from 'civil-status/constants/code-subject-section';

interface ActDigitalProps {
  disabled?: boolean;
  values?: ActFormVM;
  errors?: FormikErrors<ActFormVM>;
  touched?: FormikTouched<ActFormVM>;
  onChange: (key: keyof ActFormVM, value: ActFormVM[keyof ActFormVM]) => void;
  onChanges: (values: ActFormVM) => void;
  configuration?: string;
  nothingRequired?: boolean;
  isLastStepEmergency?: boolean;
  withPresentationDocument?: boolean;
  isRequiredData?: boolean;
  isRactod343?: boolean;
  isRactod344?: boolean;
  isRactod341?: boolean;
  isRactod441?: boolean;
  isRactod350?: boolean;
  isRactod0216?: boolean;
  isRactod0103?: boolean;
  isAtcoDRM?: boolean;
  isAtcoDRMA?: boolean;
  isAtcoDRMM?: boolean;
  isAtcoDRMU?: boolean;
  formContext: FormikProps<LastStepVM>;
  onDelete: () => void;
  idEvento?: number;
  codeSection?: string;
  idCat?: string;
  onSave: () => void;
}

const ActDigitalComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
  onChanges,
  nothingRequired = false,
  isLastStepEmergency = false,
  withPresentationDocument = false,
  isRequiredData = false,
  isRactod343 = false,
  isRactod344 = false,
  isRactod341 = false,
  isRactod441 = false,
  isRactod350 = false,
  isRactod0216 = false,
  isRactod0103 = false,
  isAtcoDRM = false,
  isAtcoDRMA = false,
  isAtcoDRMM = false,
  isAtcoDRMU = false,
  formContext,
  onDelete,
  idEvento,
  codeSection,
  idCat,
  configuration,
  onSave,
}: ActDigitalProps): React.ReactElement => {
  const [openAct, setOpenAct] = useState<boolean>(true);
  const [tableProps, setTableProps] = useState<Record<string, number>>({
    page: 0,
    rowsPerPage: 10,
  });
  const [itemSavedData, setItemSavedData] = useState<ModelEventoDTO>({});
  // filtri selezionati
  const [filterSelected, setFilterSelected] = useState<FilterTypeState>({
    url: '',
    filter: {},
  });

  const [actList, getActList] = useHttpFetch<HttpResponse<ActCategory>, Array<ActListVM>>(
    `${__ACT_API_URL__}/consultazione/evento`,
    {
      onBootstrap: false,
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {},
      },
      transformer: transformerActCategoryList,
    }
  );

  const getActListData = useEventCallback(
    (dataFilter?: FilterType, page?: number, rowsPerPage?: number) => {
      (
        getActList({
          data: {
            ...dataFilter,
            datiPaginazione: {
              numPagina: page || 0,
              numRecordPagina: rowsPerPage || 10,
            },
          },
        }) as unknown as ResponsePromise<void>
      ).then(() => {
        // salvo i filtri dell'ultima ricerca
        setFilterSelected({
          url: `${__ACT_API_URL__}/consultazione/evento`,
          filter: dataFilter || {},
        });
      });
    }
  );

  const handleSubmitResearchAct = useEventCallback((valuesActResearch: ResearchAct) => {
    const dataFilter: FilterType = transformerActResearch(valuesActResearch);

    setTableProps({
      page: 0,
      rowsPerPage: 10,
    });

    getActListData(dataFilter);
  });

  const getData = useEventCallback((item: ActListVM) => {
    const itemSaved: ModelEventoDTO = item.itemSaved || {};

    const idAnscSplit: Array<string | undefined> = itemSaved.idAnsc
      ? itemSaved.idAnsc.split('-')
      : [];
    const municipalNumber = idAnscSplit.length >= 3 ? idAnscSplit[2] : undefined;

    const intestatari = itemSaved.intestatari || [];

    onChanges({
      // mettere item saved
      actSearched: itemSaved,
      idEventoCollegato: undefined,
      idAnsc: itemSaved.idAnsc || '',
      dateAct: itemSaved.dataformazione ? DateTime.fromISO(itemSaved.dataformazione) : null,
      municipalNumber,
      year: itemSaved.annoAtto || '',
      typeEvent: itemSaved.idtipocontenuto || '',
      register: itemSaved.idTipoEvento || '',
      italian: {
        municipality: itemSaved.nomeComuneRegistrazione
          ? {
              description: itemSaved.nomeComuneRegistrazione,
              id: itemSaved.idComuneRegistrazione || '',
              code: itemSaved.idComuneRegistrazione
                ? Number.parseInt(itemSaved.idComuneRegistrazione, 10)
                : undefined,
              idProvince: itemSaved.idProvinciaRegistrazione
                ? Number.parseInt(itemSaved.idProvinciaRegistrazione, 10)
                : undefined,
              province: itemSaved.siglaProvinciaRegistrazione || '',
            }
          : undefined,
      },
      nameSurnameGroom: `${intestatari[0]?.cognome || ''} ${intestatari[0]?.nome || ''}`,
      nameSurnameWife: `${intestatari[1]?.cognome || ''} ${intestatari[1]?.nome || ''}`,
      useCase: itemSaved.idUsecase || '',
      descUseCase: itemSaved.descrizioneCasoUso || '',
    });

    setItemSavedData(itemSaved);
    setOpenAct(false);
    actList.data = undefined;
  });

  const checkElement = useHttpClient('', {
    options: {
      method: 'GET',
      loading: true,
      errorCatching: true,
    },
  });

  const onChoosePress = useEventCallback((item: ActListVM) => {
    if (isAtcoDRM && codeSection === CodeSection.ATTO_DA_RETTIFICARE) {
      (
        checkElement({
          url: `${__ACT_API_URL__}/bozza/verifica-presenza/${item.idAnsc}`,
        }) as ResponsePromise<void>
      ).then(() => {
        getData(item);
      });

      return;
    }

    getData(item);
  });

  const deleteData = useHttpClient('', {
    options: {
      method: 'DELETE',
      loading: true,
      errorCatching: true,
    },
  });

  const deleteSubject = useEventCallback((arrSubjectDelete: Array<ParentVM | undefined>) => {
    arrSubjectDelete.forEach((itemSubject) => {
      if (!Boolean(itemSubject?.generality?.idSubject)) {
        return;
      }

      deleteData({
        url: `${__ACT_API_URL__}/soggetto/rimuovi/idEvento/${idEvento}/codiceSoggetto/${
          itemSubject?.codeSubject
        }/idSoggetto/${itemSubject?.generality?.idSubject || ''}`,
      });
    });
  });

  const updateDataWife = useEventCallback(() => {
    if (isAtcoDRMM || isAtcoDRMU) {
      const intestatari = itemSavedData.intestatari || [];

      // Soggetti
      const sposa = transformerParent(intestatari[1]);

      // soggetti da eliminare se salvati sul DB
      const arrSubjectDelete: Array<ParentVM | undefined> = [
        formContext.values[KeySubjects.keyIntAnn],
      ];

      // eliminare i soggetti salvati sul DB
      deleteSubject(arrSubjectDelete);

      const newValues = {
        ...formContext.values,
        // Soggetti
        [KeySubjects.keyIntAnn]: {
          ...(formContext.values[KeySubjects.keyIntAnn] || {}),
          searchPerson: {
            ...(sposa?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(sposa?.generality || {}),
          },
        } as ParentVM,
      };

      formContext.setValues(newValues);
      toast.success('Operazione eseguita con successo');
      return;
    }
  });

  const updateDataGroom = useEventCallback(() => {
    if (isAtcoDRMM || isAtcoDRMU) {
      const intestatari = itemSavedData.intestatari || [];

      // Soggetti
      const sposo = transformerParent(intestatari[0]);

      // soggetti da eliminare se salvati sul DB
      const arrSubjectDelete: Array<ParentVM | undefined> = [
        formContext.values[KeySubjects.keyIntAnn],
      ];

      // eliminare i soggetti salvati sul DB
      deleteSubject(arrSubjectDelete);

      const newValues = {
        ...formContext.values,
        // Soggetti
        [KeySubjects.keyIntAnn]: {
          ...(formContext.values[KeySubjects.keyIntAnn] || {}),
          searchPerson: {
            ...(sposo?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(sposo?.generality || {}),
          },
        } as ParentVM,
      };

      formContext.setValues(newValues);
      toast.success('Operazione eseguita con successo');
      return;
    }
  });

  const updateData = useEventCallback(() => {
    if (isRactod343 || isRactod344) {
      const intestatari = itemSavedData.intestatari || [];
      const { separazione } = itemSavedData;

      // Soggetti
      const sposo = transformerParent(intestatari[0]);
      const sposa = transformerParent(intestatari[1]);
      const avvocato1 = transformerLawyer(
        separazione?.avvocatoConiuge1,
        separazione?.foroAvvocatoConiuge1
      );
      const avvocato2 = transformerLawyer(
        separazione?.avvocatoConiuge2,
        separazione?.foroAvvocatoConiuge2
      );
      // Sezioni
      const datiGenerali = isRactod344
        ? transformerGeneralData341(itemSavedData)
        : transformerGeneralData(itemSavedData);
      const matrimonioAtto = transformerMarriageAct(itemSavedData);
      const separazioneAtto = transformerSeparationAct(itemSavedData);

      // soggetti da eliminare se salvati sul DB
      const arrSubjectDelete: Array<ParentVM | undefined> = [
        formContext.values[KeySubjects.keySposo],
        formContext.values[KeySubjects.keySposa],
        formContext.values[KeySubjects.keyAvvoc1],
        formContext.values[KeySubjects.keyAvvoc1],
      ];

      // eliminare i soggetti salvati sul DB
      deleteSubject(arrSubjectDelete);

      let newValues = {
        ...formContext.values,
        // Soggetti
        [KeySubjects.keySposo]: {
          ...(formContext.values[KeySubjects.keySposo] || {}),
          searchPerson: {
            ...(sposo?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(sposo?.generality || {}),
          },
        } as ParentVM,
        [KeySubjects.keySposa]: {
          ...(formContext.values[KeySubjects.keySposa] || {}),
          searchPerson: {
            ...(sposa?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(sposa?.generality || {}),
          },
        } as ParentVM,
        [KeySubjects.keyAvvoc1]: {
          ...(formContext.values[KeySubjects.keyAvvoc1] || {}),
          searchPerson: {
            ...(avvocato1?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(avvocato1?.generality || {}),
          },
        } as ParentVM,
        [KeySubjects.keyAvvoc2]: {
          ...(formContext.values[KeySubjects.keyAvvoc2] || {}),
          searchPerson: {
            ...(avvocato2?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(avvocato2?.generality || {}),
          },
        } as ParentVM,
        // Sezioni
        [KeySections.keyMatrimonioAtto]: {
          ...clearSection(formContext.values[KeySections.keyMatrimonioAtto] || {}),
          ...(matrimonioAtto || {}),
        } as SectionVM,
        [KeySections.keyAccordoSeparazione]: {
          ...clearSection(formContext.values[KeySections.keyAccordoSeparazione] || {}),
          ...(separazioneAtto || {}),
        } as SectionVM,
      };

      if (Boolean(formContext.values[KeySections.keyDatiSepar])) {
        // controllo per datiSepar
        newValues = {
          ...newValues,
          [KeySections.keyDatiSepar]: {
            ...clearSection(formContext.values[KeySections.keyDatiSepar] || {}),
            ...(datiGenerali || {}),
          } as SectionVM,
        };
      }

      formContext.setValues(newValues);
      toast.success('Operazione eseguita con successo');
      return;
    }

    if (isRactod441) {
      const intestatari = itemSavedData.intestatari || [];
      // Soggetti
      const uniCiv1 = transformerParent(intestatari[0]);
      const uniCiv2 = transformerParent(intestatari[1]);
      // Sezioni
      const scioglimentoAttoUnioneCivile = transformerActCurrent(itemSavedData);

      // soggetti da eliminare se salvati sul DB
      const arrSubjectDelete: Array<ParentVM | undefined> = [
        formContext.values[KeySubjects.keyUniciv1Scio],
        formContext.values[KeySubjects.keyUniciv2Scio],
      ];

      // eliminare i soggetti salvati sul DB
      deleteSubject(arrSubjectDelete);

      formContext.setValues({
        ...formContext.values,
        // Soggetti
        [KeySubjects.keyUniciv1Scio]: {
          ...(formContext.values[KeySubjects.keyUniciv1Scio] || {}),
          searchPerson: {
            ...(uniCiv1?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(uniCiv1?.generality || {}),
          },
        } as ParentVM,
        [KeySubjects.keyUniciv2Scio]: {
          ...(formContext.values[KeySubjects.keyUniciv2Scio] || {}),
          searchPerson: {
            ...(uniCiv2?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(uniCiv2?.generality || {}),
          },
        } as ParentVM,
        // Sezioni
        [KeySections.keyScioglimentoAttoUnioneCivile]: {
          ...clearSection(formContext.values[KeySections.keyScioglimentoAttoUnioneCivile] || {}),
          ...(scioglimentoAttoUnioneCivile || {}),
        } as SectionVM,
      });

      toast.success('Operazione eseguita con successo');
      return;
    }

    if (isRactod350) {
      const intestatari = itemSavedData.intestatari || [];
      // Soggetti
      const sposo = transformerParent(intestatari[0]);
      const sposa = transformerParent(intestatari[1]);
      // Sezioni
      const matrimonioAtto = transformerActMarriageRactod350(itemSavedData);
      const datiRiconciliazione = transformerDatiRico350(itemSavedData);
      const separazione = transformerSeperazione(itemSavedData);
      const negoziazioneAssistita = itemSavedData?.negoziazioneAssistita
        ? transformerActCurrent(itemSavedData)
        : undefined;
      const confermaAccordoSeprazione = itemSavedData?.separazione
        ? transformerActCurrent(itemSavedData)
        : undefined;
      const matrimonioAttoNascitaSposo = transformerMatrimonioAttoNascitaSposo(itemSavedData);
      const matrimonioAttoNascitaSposa = transformerMatrimonioAttoNascitaSposa(itemSavedData);

      // soggetti da eliminare se salvati sul DB
      const arrSubjectDelete: Array<ParentVM | undefined> = [
        formContext.values[KeySubjects.keySposa],
        formContext.values[KeySubjects.keySposo],
      ];

      // eliminare i soggetti salvati sul DB
      deleteSubject(arrSubjectDelete);

      formContext.setValues({
        ...formContext.values,
        // Soggetti
        [KeySubjects.keySposo]: {
          ...(formContext.values[KeySubjects.keySposo] || {}),
          searchPerson: {
            ...(sposo?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(sposo?.generality || {}),
          },
        } as ParentVM,
        [KeySubjects.keySposa]: {
          ...(formContext.values[KeySubjects.keySposa] || {}),
          searchPerson: {
            ...(sposa?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(sposa?.generality || {}),
          },
        } as ParentVM,
        // Sezioni
        [KeySections.keyMatrimonioAtto]: {
          ...clearSection(formContext.values[KeySections.keyMatrimonioAtto] || {}),
          ...(matrimonioAtto || {}),
        } as SectionVM,
        [KeySections.keyDatiRiconciliazione]: {
          ...clearSection(formContext.values[KeySections.keyDatiRiconciliazione] || {}),
          ...(datiRiconciliazione || {}),
        } as SectionVM,
        [KeySections.keyNegoziazioneAssistita]: {
          ...clearSection(formContext.values[KeySections.keyNegoziazioneAssistita] || {}),
          ...(negoziazioneAssistita || {}),
          isRequiredFromOtherAccordion: Boolean(negoziazioneAssistita),
        } as SectionVM,
        [KeySections.keyAccordoSeparazione]: {
          ...clearSection(formContext.values[KeySections.keyAccordoSeparazione] || {}),
          ...(separazione || {}),
          isRequiredFromOtherAccordion: Boolean(separazione),
        } as SectionVM,
        [KeySections.keyConfermaAccordoSep]: {
          ...clearSection(formContext.values[KeySections.keyConfermaAccordoSep] || {}),
          ...(confermaAccordoSeprazione || {}),
          isRequiredFromOtherAccordion: Boolean(confermaAccordoSeprazione),
        } as SectionVM,
        [KeySections.keyMatrimonioAttoNascitaSposo]: {
          ...clearSection(formContext.values[KeySections.keyMatrimonioAttoNascitaSposo] || {}),
          ...(matrimonioAttoNascitaSposo || {}),
        } as SectionVM,
        [KeySections.keyMatrimonioAttoNascitaSposa]: {
          ...clearSection(formContext.values[KeySections.keyMatrimonioAttoNascitaSposa] || {}),
          ...(matrimonioAttoNascitaSposa || {}),
        } as SectionVM,
      });

      toast.success('Operazione eseguita con successo');
      return;
    }

    if (isRactod341) {
      const intestatari = itemSavedData.intestatari || [];
      // Soggetti
      const sposo = transformerParent(intestatari[0]);
      const sposa = transformerParent(intestatari[1]);
      // Sezioni
      const datiGenerali = transformerGeneralData341(itemSavedData);
      const matrimonioAtto = transformerActCurrent(itemSavedData);
      const matrimonioAttoNascitaSposo = transformerMatrimonioAttoNascitaSposo(itemSavedData);
      const matrimonioAttoNascitaSposa = transformerMatrimonioAttoNascitaSposa(itemSavedData);

      // soggetti da eliminare se salvati sul DB
      const arrSubjectDelete: Array<ParentVM | undefined> = [
        formContext.values[KeySubjects.keySposa],
        formContext.values[KeySubjects.keySposo],
      ];

      // eliminare i soggetti salvati sul DB
      deleteSubject(arrSubjectDelete);

      let newValues = {
        ...formContext.values,
        // Soggetti
        [KeySubjects.keySposo]: {
          ...(formContext.values[KeySubjects.keySposo] || {}),
          searchPerson: {
            ...(sposo?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(sposo?.generality || {}),
          },
        } as ParentVM,
        [KeySubjects.keySposa]: {
          ...(formContext.values[KeySubjects.keySposa] || {}),
          searchPerson: {
            ...(sposa?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(sposa?.generality || {}),
          },
        } as ParentVM,
        // Sezioni
        [KeySections.keyMatrimonioAtto]: {
          ...clearSection(formContext.values[KeySections.keyMatrimonioAtto] || {}),
          ...(matrimonioAtto || {}),
        } as SectionVM,
        [KeySections.keyMatrimonioAttoNascitaSposo]: {
          ...clearSection(formContext.values[KeySections.keyMatrimonioAttoNascitaSposo] || {}),
          ...(matrimonioAttoNascitaSposo || {}),
        } as SectionVM,
        [KeySections.keyMatrimonioAttoNascitaSposa]: {
          ...clearSection(formContext.values[KeySections.keyMatrimonioAttoNascitaSposa] || {}),
          ...(matrimonioAttoNascitaSposa || {}),
        } as SectionVM,
      };

      if (Boolean(formContext.values[KeySections.keyDatiSepar])) {
        // controllo per datiSepar
        newValues = {
          ...newValues,
          [KeySections.keyDatiSepar]: {
            ...clearSection(formContext.values[KeySections.keyDatiSepar] || {}),
            ...(datiGenerali || {}),
          } as SectionVM,
        };
      }

      formContext.setValues(newValues);
      toast.success('Operazione eseguita con successo');
      return;
    }

    if (isRactod0103) {
      // Soggetti
      const padre = transformerParent(itemSavedData.padre);
      const madre = transformerParent(itemSavedData.madre);
      // Sezioni
      const isRiconosciutoEntrambi =
        itemSavedData.idUsecase === '12214300' || itemSavedData.idUsecase === '12216300';

      const isCurrentRiconoscimentoPadre = itemSavedData.idUsecase === '12211312';
      const isCurrentRiconoscimentoMadre =
        itemSavedData.idUsecase === '12212300' || itemSavedData.idUsecase === '12212300';

      const riconoscimentoPadre =
        isCurrentRiconoscimentoPadre || isRiconosciutoEntrambi
          ? transformerActCurrent(itemSavedData)
          : transformerGeneralAct(itemSavedData.riconoscimentoPadre?.atto);
      const riconoscimentoMadre =
        isCurrentRiconoscimentoMadre || isRiconosciutoEntrambi
          ? transformerActCurrent(itemSavedData)
          : transformerGeneralAct(itemSavedData.riconoscimentoMadre?.atto);

      // soggetti da eliminare se salvati sul DB
      const arrSubjectDelete: Array<ParentVM | undefined> = [
        formContext.values[KeySubjects.keyPadre],
        formContext.values[KeySubjects.keyMadre],
      ];

      // eliminare i soggetti salvati sul DB
      deleteSubject(arrSubjectDelete);

      formContext.setValues({
        ...formContext.values,
        // Soggetti
        [KeySubjects.keyPadre]: {
          ...(formContext.values[KeySubjects.keyPadre] || {}),
          searchPerson: {
            ...(padre?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(padre?.generality || {}),
          },
        } as ParentVM,
        [KeySubjects.keyMadre]: {
          ...(formContext.values[KeySubjects.keyMadre] || {}),
          searchPerson: {
            ...(madre?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(madre?.generality || {}),
          },
        } as ParentVM,
        // Sezioni
        [KeySections.keyAttoRiconoscimentoPadre]: {
          ...clearSection(formContext.values[KeySections.keyAttoRiconoscimentoPadre] || {}),
          ...(riconoscimentoPadre || {}),
        } as SectionVM,
        [KeySections.keyAttoRiconoscimentoMadre]: {
          ...clearSection(formContext.values[KeySections.keyAttoRiconoscimentoMadre] || {}),
          ...(riconoscimentoMadre || {}),
        } as SectionVM,
      });

      toast.success('Operazione eseguita con successo');
      return;
    }

    if (isRactod0216) {
      // Soggetti
      const padre = transformerParent(itemSavedData.padre);
      const madre = transformerParent(itemSavedData.madre);
      // Sezioni
      const isWithRiconoscimentoMadre = itemSavedData.idUsecase === '12422300';

      const riconoscimentoMadre = isWithRiconoscimentoMadre
        ? transformerGeneralAct(itemSavedData.riconoscimentoMadre?.atto)
        : transformerActCurrent(itemSavedData);

      // soggetti da eliminare se salvati sul DB
      const arrSubjectDelete: Array<ParentVM | undefined> = [
        formContext.values[KeySubjects.keyMadre],
        formContext.values[KeySubjects.keyPadre],
      ];

      // eliminare i soggetti salvati sul DB
      deleteSubject(arrSubjectDelete);

      let newValues = {
        ...formContext.values,
        // Soggetti
        [KeySubjects.keyPadre]: {
          ...(formContext.values[KeySubjects.keyPadre] || {}),
          searchPerson: {
            ...(padre?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(padre?.generality || {}),
          },
        } as ParentVM,
        [KeySubjects.keyMadre]: {
          ...(formContext.values[KeySubjects.keyMadre] || {}),
          searchPerson: {
            ...(madre?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(madre?.generality || {}),
          },
        } as ParentVM,
        // Sezioni
        [KeySections.keyAttoRiconoscimentoMadre]: {
          ...clearSection(formContext.values[KeySections.keyAttoRiconoscimentoMadre] || {}),
          ...(riconoscimentoMadre || {}),
        } as SectionVM,
      };

      if (isWithRiconoscimentoMadre) {
        const attoDiConsenso = transformerActCurrent(itemSavedData);

        newValues = {
          ...newValues,
          // Sezioni
          [KeySections.keyDatiGeneraliConsRicoSent]: {
            ...(formContext.values[KeySections.keyDatiGeneraliConsRicoSent] || {}),
            typologyConsent: IDTypologyConsent.Consenso2,
          } as SectionVM,
          [KeySections.keyAttoDiConsensoAtcoP]: {
            ...clearSection(formContext.values[KeySections.keyAttoDiConsensoAtcoP] || {}),
            ...(attoDiConsenso || {}),
            isRequiredFromOtherAccordion: true,
          } as SectionVM,
        };
      }

      formContext.setValues(newValues);

      toast.success('Operazione eseguita con successo');
      return;
    }

    if (isAtcoDRMA) {
      const intestatari = itemSavedData.intestatari || [];
      // Soggetti
      const intestatario = transformerParent(intestatari[0]);

      // soggetti da eliminare se salvati sul DB
      const arrSubjectDelete: Array<ParentVM | undefined> = [
        formContext.values[KeySubjects.keyIntAnn],
      ];

      // eliminare i soggetti salvati sul DB
      deleteSubject(arrSubjectDelete);

      const newValues = {
        ...formContext.values,
        // Soggetti
        [KeySubjects.keyIntAnn]: {
          ...(formContext.values[KeySubjects.keyIntAnn] || {}),
          searchPerson: {
            ...(intestatario?.searchPerson || {}),
          },
          generality: {
            ...initialValuesParent.generality,
            ...(intestatario?.generality || {}),
          },
        } as ParentVM,
      };

      formContext.setValues(newValues);
      toast.success('Operazione eseguita con successo');
      return;
    }
  });

  const onDeleteData = useEventCallback(() => {
    setItemSavedData({});
    onDelete();
  });

  const initialValuesFilter: ResearchAct | undefined = useMemo(() => {
    if (isRactod343 || isRactod344 || isRactod341 || isRactod350) {
      return {
        idCat: ID_REGISTER.MATRIMONIO,
        dateEnd: undefined,
        dateStart: undefined,
        idAct: undefined,
        municipality: MUNICIPALITY_MILANO,
        stateAct: undefined,
        idEvent: undefined,
      };
    }

    if (isRactod441) {
      return {
        idCat: ID_REGISTER.UNIONE_CIVILE,
        dateEnd: undefined,
        dateStart: undefined,
        idAct: undefined,
        municipality: MUNICIPALITY_MILANO,
        stateAct: undefined,
        idEvent: undefined,
      };
    }

    if (isRactod0216 || isRactod0103) {
      return {
        idCat: ID_REGISTER.NASCITA,
        dateEnd: undefined,
        dateStart: undefined,
        idAct: undefined,
        municipality: MUNICIPALITY_MILANO,
        stateAct: undefined,
        idEvent: undefined,
      };
    }

    if (isAtcoDRM || isAtcoDRMA || isAtcoDRMM || isAtcoDRMU) {
      return {
        idCat,
        dateEnd: undefined,
        dateStart: undefined,
        idAct: undefined,
        municipality: MUNICIPALITY_MILANO,
        stateAct: undefined,
        idEvent: undefined,
      };
    }

    return undefined;
  }, [
    isRactod343,
    isRactod344,
    isRactod341,
    isRactod0216,
    isRactod0103,
    isRactod441,
    isRactod350,
    isAtcoDRM,
    isAtcoDRMA,
    isAtcoDRMM,
    isAtcoDRMU,
    idCat,
  ]);

  const register: string | undefined = useMemo(() => {
    // Inserire qui il default registro per tipo configurazione
    if (
      configuration === ConfigurationType.ATCOBASEN ||
      configuration === ConfigurationType.ATCOFAN ||
      configuration === ConfigurationType.ATCOBASEDN
    ) {
      return ID_REGISTER.NASCITA;
    }
    if (isAtcoDRM || isAtcoDRMA || isAtcoDRMM || isAtcoDRMU) {
      return idCat;
    }

    return;
  }, [isAtcoDRM, isAtcoDRMA, isAtcoDRMM, isAtcoDRMU, idCat, configuration]);

  const municipality: MunicipalityAnprVM | undefined = useMemo(() => {
    // Inserire qui il default comune per tipo configurazione nella ricerca dell'atto digitale
    if (isAtcoDRM || isAtcoDRMA || isAtcoDRMM || isAtcoDRMU) {
      return MUNICIPALITY_MILANO;
    }

    return;
  }, [isAtcoDRM, isAtcoDRMA, isAtcoDRMM, isAtcoDRMU]);

  const isResearchOldAct: boolean = useMemo(() => {
    return (
      isRactod343 ||
      isRactod344 ||
      isRactod341 ||
      isRactod0103 ||
      isRactod0216 ||
      isRactod441 ||
      isRactod350 ||
      isAtcoDRMA ||
      isAtcoDRMM ||
      isAtcoDRMU
    );
  }, [
    isRactod343,
    isRactod344,
    isRactod341,
    isRactod0103,
    isRactod0216,
    isRactod441,
    isRactod350,
    isAtcoDRMA,
    isAtcoDRMM,
    isAtcoDRMU,
  ]);

  return (
    <Fragment>
      <Grid container spacing={2} item>
        <Grid item xs={12}>
          {initialValuesFilter ? (
            <FilterAccordionAct
              openAct={openAct}
              setOpenAct={setOpenAct}
              handleSubmitResearchAct={handleSubmitResearchAct}
              initialValues={initialValuesFilter}
              isWithoutInitialContext
              disabledRegister={isAtcoDRM || isAtcoDRMA || isAtcoDRMM || isAtcoDRMU}
              disabledMunicipality={isAtcoDRM || isAtcoDRMA || isAtcoDRMM || isAtcoDRMU}
            />
          ) : (
            <FilterAccordionAct
              openAct={openAct}
              setOpenAct={setOpenAct}
              handleSubmitResearchAct={handleSubmitResearchAct}
              disabledRegister={isAtcoDRM || isAtcoDRMA || isAtcoDRMM || isAtcoDRMU}
              disabledMunicipality={isAtcoDRM || isAtcoDRMA || isAtcoDRMM || isAtcoDRMU}
            />
          )}
        </Grid>
        {actList.data ? (
          ((actList.data as Array<ActListVM>) || [])?.length > 0 ? (
            <TableAct
              data={actList.data as Array<ActListVM>}
              filterSelected={filterSelected}
              setFilterSelected={setFilterSelected}
              getActListData={(_, data?: FilterType, page?: number, rowsPerPage?: number) =>
                getActListData(data, page, rowsPerPage)
              }
              tableProps={tableProps}
              setTableProps={setTableProps}
              isChooseAct
              onChoosePress={onChoosePress}
              isRactod343={isRactod343}
              isRactod344={isRactod344}
              isRactod341={isRactod341}
              isRactod441={isRactod441}
              isRactod350={isRactod350}
              isRactod0216={isRactod0216}
              isRactod0103={isRactod0103}
            />
          ) : (
            <Typography color="secondary.main">
              Nessun elemento trovato con la ricerca effettuata.
            </Typography>
          )
        ) : undefined}
        <ActForm
          onChange={onChange}
          onChanges={onChanges}
          values={values}
          //disabled={isLastStepEmergency ? false : disabled || isResearchOldAct}
          disabled={isLastStepEmergency ? false : true}
          nothingRequired={nothingRequired || isResearchOldAct}
          withPresentationDocument={withPresentationDocument}
          register={register}
          municipality={municipality}
          isRequiredData={isRequiredData}
          errors={errors as FormikErrors<ActFormVM> | undefined}
          touched={touched as FormikTouched<ActFormVM> | undefined}
          isRactod343={isRactod343 || isRactod344}
        />
      </Grid>
      {isResearchOldAct ? (
        <Grid item xs={12} display="flex" justifyContent="center">
          <PmiButton color="cdmBrand" variant="outlined" onClick={onDeleteData} disabled={disabled}>
            Pulisci
          </PmiButton>
          {isAtcoDRMM || isAtcoDRMU ? (
            <Fragment>
              <PmiButton
                color="cdmBrandThird"
                variant="outlined"
                onClick={updateDataGroom}
                disabled={disabled}
                style={{ marginLeft: '1rem' }}
              >
                {isAtcoDRMU ? 'Acquisisci dati Unito 1' : 'Acquisisci dati Sposo'}
              </PmiButton>
              <PmiButton
                color="cdmBrandThird"
                variant="outlined"
                onClick={updateDataWife}
                disabled={disabled}
                style={{ marginLeft: '1rem' }}
              >
                {isAtcoDRMU ? 'Acquisisci dati Unito 2' : 'Acquisisci dati Sposa'}
              </PmiButton>
            </Fragment>
          ) : (
            <PmiButton
              color="cdmBrandThird"
              variant="outlined"
              onClick={updateData}
              disabled={disabled}
              style={{ marginLeft: '1rem' }}
            >
              Acquisisci dati
            </PmiButton>
          )}
          {isAtcoDRMA || isAtcoDRMM || isAtcoDRMU ? (
            <PmiButton
              color="cdmBrandThird"
              variant="outlined"
              onClick={onSave}
              disabled={disabled}
              style={{ marginLeft: '1rem' }}
            >
              Salva
            </PmiButton>
          ) : undefined}
        </Grid>
      ) : undefined}
    </Fragment>
  );
};

ActDigitalComponent.displayName = 'Form Act Digital component';

const ActDigital = memo(ActDigitalComponent);

export default ActDigital;
